function escapeHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/**
 * Lightweight Discord-ish markdown for dashboard embed previews.
 */
export function formatDiscordPreviewHtml(text, vars = {}) {
  if (!text) return "";

  const {
    userName = "New Member",
    serverName = "Nocturne",
    count = "0",
    prize = "Discord Nitro",
    host = userName,
    winners = "1",
    winnerList = userName,
    ends = "in 2 days",
    emoji = "🎉",
    requirements = "",
  } = vars;

  const mentionName = (name) =>
    `<span class="mention">@${escapeHtml(String(name || "").replace(/^@/, ""))}</span>`;

  let html = escapeHtml(text)
    .replace(/{user}/g, `<span class="mention">@${userName}</span>`)
    .replace(/{userName}/g, userName)
    .replace(/{server}/g, serverName)
    .replace(/{memberCount}/g, count)
    .replace(/{count}/g, count)
    .replace(/\{prize\}/gi, escapeHtml(String(prize)))
    .replace(/\{host\}/gi, mentionName(host))
    .replace(/\{winners\}/gi, escapeHtml(String(winners)))
    .replace(/\{winnerList\}/gi, mentionName(winnerList))
    .replace(/\{ends\}/gi, `<span class="mention">${escapeHtml(String(ends))}</span>`)
    .replace(/\{emoji\}/gi, escapeHtml(String(emoji)))
    .replace(/\{requirements\}/gi, escapeHtml(String(requirements)).replace(/\n/g, "<br/>"))
    .replace(/<#(\d+)>/g, '<span class="mention">#linked-channel</span>');

  html = html
    .replace(/\*\*(.+?)\*\*/gs, "<strong>$1</strong>")
    .replace(/__(.+?)__/gs, "<u>$1</u>")
    .replace(/(?<!\*)\*([^*\n]+?)\*(?!\*)/g, "<em>$1</em>")
    .replace(/^&gt; (.+)$/gm, "<blockquote>$1</blockquote>");

  return html;
}
